import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { CASE_MANAGEMENT_REPORT_QUERY } from '../../../graphql.js'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import './CaseManagementReport.css'
import { csvUrl, getData } from '../CustomUtils.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ResultsGrid from '../ResultsGrid.js'
import ParameterValues from '../ParameterValues.js'
import ReportHeading from '../ReportHeading.js'
import LargeRowHandler from '../LargeRowHandler.js'

const CASE_MANAGEMENT_REPORT = gql(CASE_MANAGEMENT_REPORT_QUERY)

export default function CaseManagementReport({ location }) {
  console.log('CaseManagementReport rendered:', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, CASE_MANAGEMENT_REPORT, 'caseManagementReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const resultRows = ResultsGrid(results, 0)
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('HBFuller/caseManagementReport/case_management_report', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white'}} >
          <ReportHeading title={'H.B. Fuller Case Management Report'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}